<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <v-form>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="auto">
              <mrc_ess_switch :true-value="1"
                              :false-value="0"
                              v-model="params.is_enable_auth"
                              @change='is_enable_auth_change'
                              :readonly="disabled"
                              :true-text="$t('label_enable_two_step_verification')"
                              :false-text="$t('label_disable_two_step_verification')">
              </mrc_ess_switch>
            </v-col>
            <v-col cols="12"
                   sm="12">
              <mrc_ess_dictName v-model="params.auth_type"
                                v-if="params.is_enable_auth==1"
                                :placeholder="$t('label_code_acceptance_method')"
                                :disabled="disabled"
                                :errMsg="
                  $errors('params', 'auth_type', [{
                         rule: 'auth_type_equired',
                         msg: $t('message_code_acceptance_method_is_required')
                         }])"
                                :label="$t('label_code_acceptance_method')"
                                :rules="false"
                                dict_name="auth_type">
              </mrc_ess_dictName>
            </v-col>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn @cancel="cancel"
                           v-if="!disabled"
                           :loading="loading"
                           @success="success"></mrc_ess_submitBtn>
      </v-card>
    </v-form>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  add_update_auth, find_auth
} from "@/service/api/company_set"
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data () {
    return {
      loading: false,
      skLoading: true,
      params: {
        uuid: "",
        org_level_uuid: "",
        client_uuid: "",
        is_enable_auth: 0,
        auth_type: "",
      },
    }
  },
  validations: {
    params: {
      auth_type: {
        auth_type_equired (value) {
          // console.log(value, !value, this.params.is_enable_auth, this.params.is_enable_auth == 1 && !value);
          if (this.params.is_enable_auth == 1 && !value) {
            return false
          }
          else {
            return true
          }
        },
      },
    },
  },
  created () { },
  async mounted () {
    await this.national("mrbase_sys_company")
    this.params.org_level_uuid = this.$store.state.uuid
    await this.getData()
  },
  methods: {
    is_enable_auth_change (val) {
      if (val == 0) {
        this.params.auth_type = ''
      }
    },
    async getData () {
      this.skLoading = true
      const getData = await find_auth({
        org_level_uuid: this.params.org_level_uuid,
      })
      if (getData.code == 200 && Object.keys(getData.data).length > 0) {
        this.params = getData.data
        this.params.auth_type = String(this.params.auth_type)
      }
      this.skLoading = false
    },
    cancel () {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(async () => {
          await this.getData()
          this.$emit("cancel", !this.disabled)
        })
        .catch(() => { })
    },
    async success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.loading = true
      const submit = await add_update_auth({
        uuid: this.params.uuid,
        org_level_uuid: this.$store.state.uuid,
        // client_uuid: this.params.client_uuid,
        is_enable_auth: this.params.is_enable_auth,
        auth_type: this.params.auth_type,
      })
      if (submit.code == 200) {
        await this.getData()
        this.$emit("changeiconStatus")
        this.$Message({
          text: this.$t("message_The_submission_was_successful"),
        })
      }
      else {
        this.$deleteFile(rea[0].uuid)
        this.$deleteFile(rea[1].uuid)
      }
      this.loading = false
    },
  },
  computed: {
  },
  watch: {},
}
</script>

<style scoped>
</style>
